/**
 *    Funcionalidad básica de para formularios
 *
 * El proceso consta de dos pasos
 *
 *   a) Carga de datos básicos
 *   b) Submit del formulario
 *
 * Resumen:
 *
 *   a) Carga de datos básicos / funcion load
 *      UTILIZA: loading ->  (loaded, error)
 *
 *   b) Submit del formulario / funciones create o update
 *      UTILIZA: (success, error)
 *      OBS: Jamás usa loading, eso lo maneja Formik localmente
 *
 */
import { toast } from "react-toastify";
import { getHttpClient, errorDesconocido, handle401 } from "../../../core/utils/httpClient";

export function error(error) {
    return { type: "PAYMENT_FORM_ERROR", error };
}

export function loading(loading) {
    return { type: "PAYMENT_FORM_LOADING", loading };
}

export function loaded(loaded) {
    return { type: "PAYMENT_FORM_LOADED", loaded };
}

/**
 *   Retorna los datos básicos para cargar el formuarlio
 *
 *    Podrian ser dos funciones o jugar con los argumentos para
 * saber si es 'alta' o 'edicion'
 */
export function load(id) {
    return (dispatch, getState) => {
        dispatch(loading(true));
        dispatch(error(""));

        var url;
        if (id == null) {
            url = "react/v1/payments/form";
        } else {
            url = "react/v1/payments/form/" + id;
        }

        const cliente = getHttpClient(dispatch, getState());
        cliente.then((axios) => {
            axios
                .get(url)
                .then((resp) => {
                    dispatch(loading(false));
                    dispatch(loaded(resp.data));
                })
                .catch(handle401(dispatch, getState))
                .catch((e) => {
                    errorDesconocido();
                    dispatch(loading(false));
                    dispatch(error("Error "));
                });
        });
    };
}

export function success(success) {
    return { type: "PAYMENT_FORM_SUCCESS", success };
}

export function create(form) {
    return async (dispatch, getState) => {
        dispatch(success(false));
        dispatch(error(""));

        var headers = {
            "Content-Type": "application/json",
        };

        try {
            const cliente = await getHttpClient(dispatch, getState());
            const response = await cliente.post("react/v1/payments/form", form, { headers: headers });

            dispatch(success(true));

            return response.data;
        } catch (e) {
            /*.catch(handle401(dispatch, getState))*/
            dispatch(success(false));
            if (e.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                if (e.response.status == 404) {
                    dispatch(error(e.response.data));
                    alert("Error 404 ");
                } else if (e.response.status != 400) {
                    alert("Error desconocido");
                }

                return e.response.data;
            }

            dispatch(error("Error desconocido"));
            errorDesconocido();
            return "Error";
        }
    };
}

export function createFromPO(id, form) {
    return async (dispatch, getState) => {
        dispatch(success(false));
        dispatch(error(""));

        var headers = {
            "Content-Type": "application/json",
        };

        try {
            const cliente = await getHttpClient(dispatch, getState());
            const response = await cliente.post("react/v1/payments/formPO/" + id, form, { headers: headers });

            toast.success("Payment created!");
            dispatch(success(true));

            return response.data;
        } catch (e) {
            /*.catch(handle401(dispatch, getState))*/
            dispatch(success(false));
            if (e.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                if (e.response.status == 404) {
                    dispatch(error(e.response.data));
                    alert("Error 404 ");
                } else if (e.response.status != 400) {
                    alert("Error desconocido");
                }

                return e.response.data;
            }

            dispatch(error("Error desconocido"));
            errorDesconocido();
            return "Error";
        }
    };
}

export function update(id, form) {
    return async (dispatch, getState) => {
        dispatch(success(false));
        dispatch(error(""));

        var headers = {
            "Content-Type": "application/json",
        };

        try {
            const cliente = await getHttpClient(dispatch, getState());
            const response = await cliente.put("react/v1/payments/form/" + id, form, { headers: headers });

            dispatch(success(true));

            return response.data;
        } catch (e) {
            /*.catch(handle401(dispatch, getState))*/
            dispatch(success(false));
            if (e.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                if (e.response.status == 404) {
                    dispatch(error(e.response.data));
                    alert("Error 404");
                } else if (e.response.status != 400) {
                    alert("Error desconocido");
                }
                return e.response.data;
            }

            dispatch(error("Error desconocido"));
            errorDesconocido();
            return "Error";
        }
    };
}

export function reset() {
    return { type: "PAYMENT_FORM_RESET" };
}
